import React, {useEffect, useState, useCallback} from "react";
import MessageIcon from "../../images/crm/messageIcon.webp";
import {GoogleIcon, YandexIcon} from "../utils/Icons";
import {fetchRequestFeedback} from "../../api/crm/feedback";
import {
    authGoogle,
    authYandex,
    logout,
} from "../header/Header";

export function FeedBack({token}) {

    const [inputFillCheck, setInputFillCheck] = useState(false)
    const [hideForm, setHideForm] = useState(true)
    const [showAutorisationForm, setShowAutorisationForm] = useState(false)
    const [inputFields, setInputFields] = useState({
        token: token,
        object: "request",
        text: "",
        contactPhone: "",
        city: "",
        name: "",
    })
    const [showAlertNoCancel, setShowAlertNoCancel] = useState(false)

    const [alertNoCancelParams, setAlertNoCancelParams] = useState({
        tittle: "Ошибка",
        buttonText: "выйти",
        message: `текст ошибки`,
        function: null,
        arguments: null,
    })

    const formState = {
        inputFields,
        hideForm,
        inputFillCheck,
        setInputFillCheck,
        setInputFields,
        setShowAutorisationForm,
        setHideForm,
        setShowAlertNoCancel,
        setAlertNoCancelParams
    }

    const getActualToken = useCallback(() => {
        if (token && token !== "") return token;
        const storedToken = localStorage.getItem('token'); // предположим, токен хранится под ключом 'token'
        if (storedToken) return storedToken;
        return "";
    }, [token]);

    // Синхронизация inputFields.token с актуальным токеном при монтировании и изменении пропа
    useEffect(() => {
        const actualToken = getActualToken();
        if (actualToken !== inputFields.token) {
            setInputFields(prev => ({ ...prev, token: actualToken }));
        }
    }, [token, getActualToken, inputFields.token]);

    function handleIconClick() {
        // Сначала проверяем состояние, если пусто – пытаемся взять из localStorage
        let currentToken = inputFields.token;
        if (!currentToken) {
            const storedToken = localStorage.getItem('token');
            if (storedToken) {
                // обновляем состояние и используем его для дальнейшей логики
                setInputFields(prev => ({ ...prev, token: storedToken }));
                currentToken = storedToken;
            }
        }

        if (currentToken === "") {
            setShowAutorisationForm(true);
            return;
        }
        setHideForm(!hideForm);
    }

    useEffect(()=>{
    }, [inputFields, inputFillCheck, showAutorisationForm])

    return (
        <>
            <AlertNoCancel showAlertConfirm={showAlertNoCancel} setShowAlertConfirm={setShowAlertNoCancel}
                           alertConfirmParams={alertNoCancelParams}/>

            <div className={"feedbackButton"} onClick={handleIconClick}>
                <img src={MessageIcon} alt="no-img"/>
            </div>

            <div className={`darkSpace ${hideForm? "" : "darkSpaceVisible"}`} onClick={() => {
                setHideForm(true)
            }}> </div>

            <div className={`darkSpace ${showAutorisationForm? "darkSpaceVisible" : ""}`} onClick={() => {
                setShowAutorisationForm(false)
            }}> </div>

            <div className="dropdown-login" style={{display: `${showAutorisationForm ? "block" : "none"}`}}>
                <div className="buttonLogin" onClick={authYandex}>
                    <YandexIcon/>
                    Войти через Яндекс ID
                </div>
                <div className="buttonLogin" onClick={authGoogle}>
                    <GoogleIcon/>
                    Войти через Google ID
                </div>
            </div>

            <FeedBackForm {...formState}/>
        </>
    )
}

function FeedBackForm({inputFields, hideForm, inputFillCheck, setInputFillCheck, setInputFields, setShowAutorisationForm, setHideForm, setShowAlertNoCancel, setAlertNoCancelParams}){

    let [loadManyRequest, setLoadManyRequest] = useState(false)

    function handleOnChange(e, key) {
        const {value} = e.target
        setInputFields(prevState => ({
            ...prevState,
            [key]: key === "text"? value : onlyText(value)
        }))
    }

    function handleOnChangeCity(e, key) {
        const {value} = e.target
        setInputFields(prevState => ({
            ...prevState,
            [key]: textDefise(value)
        }))
    }

    function handleOnChangeNumber(e, key) {
        const {value} = e.target

        setInputFields(prevState => ({
            ...prevState,
            [key]: correctNumber(value)
        }))
    }

    async function getFeedBack() {

        defenseFromManyRequest(setLoadManyRequest)

        if(!inputFields.token) {
            setShowAutorisationForm(true)
            setHideForm(true)
            return
        }

        if(!inputFields.text || inputFields.contactPhone.length !== 12 || !inputFields.city || !inputFields.name) {
            setInputFillCheck(true)
            return
        }

        setInputFillCheck(false)
        setHideForm(true)

        try {
            let answer = await fetchRequestFeedback(inputFields)
            if(answer === `пользователь с таким токеном не найден\n`) {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "выйти",
                    message: answer,
                    function: logout,
                    arguments: null})
                setShowAlertNoCancel(true)
            }
            if(answer === "many request\n") {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "продолжить",
                    message: "Разрешено отправлять не более одного вопроса раз в 30 минут",
                    function: null,
                    arguments: null})
                setShowAlertNoCancel(true)
            }
            if(answer === "ok") {
                setAlertNoCancelParams({
                    tittle: "Сообщение",
                    buttonText: "продолжить",
                    message: "Ваш запрос успешно отправлен",
                    function: null,
                    arguments: null})
                setShowAlertNoCancel(true)
            }
        } catch (error) {
            console.log("error", error)
            if(error === "пользователь с таким токеном не найден") {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "выйти",
                    message: error,
                    function: null,
                    arguments: null})
                setShowAlertNoCancel(true)
            }
        }
    }

    function fillRequired(key) {

        if(inputFillCheck && inputFields[key] === "") {
            return "feedbackFormRequiredFill"
        }

        if(key === "contactPhone" && inputFillCheck && inputFields[key].length !== 12) {
            return "feedbackFormRequiredFill"
        }

        return null
    }

    useEffect(() => {
        defenseFromManyRequest(setLoadManyRequest)
    }, [])

    return (
        <div className={`feedbackForm ${hideForm? "" : "feedbackFormVisible"}`}>
            <div>
                <div className={"feedbackFormName"}>
                    <span>Задайте свой вопрос</span>
                    <div onClick={()=>{setHideForm(true)}}>
                        <svg viewBox="0 0 23 26" width="70%" height="75%">
                            <path d="M21,4.46158263L19.5384174 3 12 10.5384174 4.46158263 3 3 4.46158263 10.5384174 12 3 19.5384174 4.46158263 21 12 13.4615826 19.5384174 21 21 19.5384174 13.4615826 12z"> </path>
                        </svg>
                    </div>
                </div>
                <div className={"feedbackFormText"}>Получите персональное предложение!
                    Оставьте ваш контакт, и мы свяжемся с вами для ответа на любые вопросы
                    Не более одного вопроса раз в 30 минут.
                </div>
                <div className={"feedbackInputGroup"}>
                    <input required maxLength="30" type="text" className={`feedbackInput ${fillRequired("name")}`} value={inputFields.name}
                           onChange={(e) => handleOnChange(e, "name")}/>
                    <label className={"feedbackPlaceholder"}>Ваше имя</label>
                </div>

                <input type="text" placeholder={"+7 (000) 000-00-00"} className={`feedbackInput ${fillRequired("contactPhone")}`} value={inputFields.contactPhone} onChange={(e) => handleOnChangeNumber(e, "contactPhone")}/>

                <div className={"feedbackInputGroup"}>
                    <input required maxLength="30" type="text" className={`feedbackInput ${fillRequired("city")}`} value={inputFields.city} onChange={(e) => handleOnChangeCity(e, "city")}/>
                    <label className={"feedbackPlaceholder"}>Город</label>
                </div>

                <div className={"feedbackInputGroup"}>
                    <textarea required maxLength="300" rows="5" cols="33" className={`feedbackInput ${fillRequired("text")}`}  value={inputFields.text} onChange={(e) => handleOnChange(e, "text")}> </textarea>
                    <label className={"feedbackPlaceholderTextArea"}>Ваш вопрос</label>
                </div>


                <div className={`feedbackRequestButton ${loadManyRequest? "noActiveButton" : ""}`} onClick={getFeedBack}><span>Задать вопрос</span></div>
            </div>
        </div>
    )
}

export function onlyText(text) {

    return text.replace(/[^\p{L}\s]/gu, '')
}

export function textDefise(text) {

    return text.replace(/[^-^\p{L}\s]/gu, '')
}

export function correctNumber(number) {

    if(number === "+7"){
        return ""
    }

    if(number.replace(/[^0-9]/g,"").length === 1) {
        return "+7" + number.replace(/[^0-9]/g,"").slice(0, 11)
    }

    if(number.replace(/[^0-9]/g,"").length === 0) {
        return ""
    }

    return "+" + number.replace(/[^0-9]/g,"").slice(0, 11)
}

export function AlertNoCancel({showAlertConfirm, setShowAlertConfirm, alertConfirmParams}) {

    function HandleConfirm() {
        if (alertConfirmParams.function) {
            if (alertConfirmParams.arguments) {
                alertConfirmParams.function(true, alertConfirmParams.arguments)
            } else {
                alertConfirmParams.function(true)
            }
        }
        setShowAlertConfirm(false)
    }

    return (
        <>
            <div className={`darkSpace darkSpaceNoPointer ${showAlertConfirm? "darkSpaceVisible" : ""}`}> </div>
            <div className={`alertConfirm ${showAlertConfirm ? "alertConfirmVisible" : null}`}>
                <h2 className="alertConfirmTittle">{alertConfirmParams.tittle}</h2>
                <p className="alertConfirmMessage">{alertConfirmParams.message}</p>
                <div className="alertConfirmButtonWrapper">
                    <button className="alertConfirmOk alertConfirmButtonHover" onClick={HandleConfirm}>{alertConfirmParams.buttonText}</button>
                </div>
            </div>
        </>

    )
}

export function defenseFromManyRequest(setFunction, time = 2000) {
    setFunction(true)
    let interval = setTimeout(() => {
        setFunction(false)
        clearInterval(interval)
    }, time)
}

